import styled from '@emotion/styled'

export const HeaderItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`

export const PayoutBlock = styled.div`
  display: block;
  width: 50%;
`

export const PayoutBlockList = styled.div`
  margin-top: 6px;
  display: flex;
  flex-direction: column;
`

export const PayoutBlockListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
`
